/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { Box, CircularProgress, useTheme } from "@mui/material";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChatBubbleOutlineRoundedIcon from "@mui/icons-material/ChatBubbleOutlineRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseIcon from "@mui/icons-material/Close";
import PullToRefresh from "../../components/PullToRefresh/PullToRefresh";
import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useContext, useEffect, useState } from "react";
import { Link as RouterLink, useNavigate, useParams, useLocation } from "react-router-dom";
import { Header } from "../../components/Header";
import UserContext from "../../context/User";
import EmbedContext from "../../context/Embed";
import Analytics from "../../utils/analytics";
import { ORDER_STATUS } from "../../utils/constantValues";
import useStyles from "./styles";
import { Chat } from "../../components/Chat";
import LiveTrackingMap from "../../components/Orders/OrderDetail/LiveTrackingMap";
import StatusBanner from "../../components/Orders/OrderDetail/StatusBanner";
import Timeline from "../../components/Orders/OrderDetail/Timeline";
import DriverCard from "../../components/Orders/OrderDetail/DriverCard";
import DeliveryDetails from "../../components/Orders/OrderDetail/DeliveryDetails";
import Receipt from "../../components/Orders/OrderDetail/Receipt";
import AppPromo from "../../components/Orders/OrderDetail/AppPromo";
import { CardTitle, DetailCard, StatusPill, outlineButtonSx, redButtonSx } from "../../components/Orders/OrderDetail/detailUi";
import { dayText, deliverySource, isInStoreOrder, isPickupOrder, orderPhase, orderTimeline, orderTz, statusBanner, statusChip, timeText } from "../../components/Orders/OrderDetail/orderProgress";
import useReorder from "../../components/Orders/useReorder";
import { BUTTON_RESET, C, FOCUS_RING, FONT_BODY, FONT_DISPLAY, VISUALLY_HIDDEN, topBarOffset } from "../../utils/designTokens";
import { useSubscription } from "@apollo/client";
import { subscriptionNewMessage } from "../../apollo/server";
import { subscriptionOrder } from "../../apollo/server";
import gql from "graphql-tag";
import Modal from "react-modal";
import { reviewOrder } from "../../apollo/server";
import { customerConfirmPickup } from "../../apollo/server";
import { submitDishVotes, myDishVotesForOrder } from "../../apollo/server";
// Apollo's useQuery is aliased — this file already declares a local useQuery()
// helper (URLSearchParams) further down that would otherwise shadow it.
import { useMutation, useQuery as useApolloQuery } from "@apollo/client";
import FlashMessage from "../../components/FlashMessage";
import ThreeDots from "../../components/ThreeDots/ThreeDots";
import StarRatings from "react-star-ratings";
import { useTranslation } from "react-i18next";

const REVIEWORDER = gql`
  ${reviewOrder}
`;

const CONFIRM_PICKUP = gql`
  ${customerConfirmPickup}
`;

const SUBMIT_DISH_VOTES = gql`
  ${submitDishVotes}
`;

const MY_DISH_VOTES = gql`
  ${myDishVotesForOrder}
`;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

// Scroll a section into view under the top bar and move focus there, so
// "Track live" works the same with a keyboard.
const goTo = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  el.scrollIntoView({ behavior: "smooth", block: "start" });
  el.focus({ preventScroll: true });
};

const TICKET = {
  RESOLVED: { dot: C.green, bg: C.greenSoft, color: C.green, title: "Refund issued", text: "Credit added to your RMF Wallet" },
  CLOSED_NO_ACTION: { dot: C.muted, bg: C.surface, color: C.muted, title: "Claim reviewed", text: "No credit was issued" },
  OPEN: { dot: C.goldAccent, bg: C.goldSoft, color: C.gold, title: "Support ticket under review", text: "We'll update you here" },
};

function ChatWithRider({ unread, onClick, floating = false }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        ...BUTTON_RESET,
        ...FOCUS_RING,
        boxSizing: "border-box",
        width: floating ? "auto" : "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        height: 48,
        px: 2.5,
        borderRadius: "999px",
        bgcolor: C.ink,
        color: "#FFFFFF",
        fontFamily: FONT_BODY,
        fontSize: 15,
        fontWeight: 700,
        boxShadow: floating ? "0 8px 24px rgba(26,25,24,0.28)" : "none",
        animation: unread > 0 ? "rmf-pulse 1.2s ease-in-out infinite" : "none",
        "@keyframes rmf-pulse": {
          "0%": { boxShadow: "0 0 0 0 rgba(196,43,31,0.7)" },
          "70%": { boxShadow: "0 0 0 14px rgba(196,43,31,0)" },
          "100%": { boxShadow: "0 0 0 0 rgba(196,43,31,0)" },
        },
        "@media (prefers-reduced-motion: reduce)": { animation: "none" },
        "&:hover": { bgcolor: "#000000" },
      }}
    >
      <ChatBubbleOutlineRoundedIcon aria-hidden="true" sx={{ fontSize: 20 }} />
      Chat with rider
      {unread > 0 && (
        <Box component="span" sx={{ minWidth: 20, height: 20, px: 0.75, boxSizing: "border-box", borderRadius: "999px", bgcolor: C.red, color: "#FFFFFF", fontSize: 12, fontWeight: 700, display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
          {unread > 9 ? "9+" : unread}
          <Box component="span" sx={VISUALLY_HIDDEN}> unread</Box>
        </Box>
      )}
    </Box>
  );
}

function Centered({ children }) {
  return (
    <Box sx={{ minHeight: "100vh", bgcolor: C.bg }}>
      <Header />
      <Box sx={{ pt: topBarOffset(80), display: "flex", justifyContent: "center", fontFamily: FONT_BODY, color: C.ink }}>{children}</Box>
    </Box>
  );
}

function OrderDetail() {
  const theme = useTheme();
  const { t } = useTranslation();
  const classes = useStyles();
  let { id } = useParams();
  const navigate = useNavigate();
  let destCoordinates = null;
  let restCoordinates = {};
  const queryParams = useQuery();
  const [toggleChat, setToggleChat] = useState(false);
  const [unreadChat, setUnreadChat] = useState(0);
  // When chat panel is open, clear the unread counter immediately.
  useEffect(() => { if (toggleChat) setUnreadChat(0); }, [toggleChat]);
  // Subscribe to incoming chat messages for this order — increment unread when
  // it's a rider message and the chat panel isn't currently open.
  useSubscription(gql`${subscriptionNewMessage}`, {
    variables: { order: id },
    skip: !id,
    onData: ({ data }) => {
      const m = data?.data?.subscriptionNewMessage;
      if (!m) return;
      const fromRider = String(m.user?._id || '').startsWith('rider:');
      if (fromRider && !toggleChat) setUnreadChat(c => c + 1);
    },
  });
  const [isOpen, setIsOpen] = useState(false);
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState("");
  const [loyaltyMsg, setLoyaltyMsg] = useState(() => {
    const msg = sessionStorage.getItem("loyaltyEarnedMessage");
    if (msg) sessionStorage.removeItem("loyaltyEarnedMessage");
    return msg || null;
  });
  const mobile = useMediaQuery(theme.breakpoints.down("md"));
  const [mutate, { loading: loadingMutation }] = useMutation(REVIEWORDER, {
    onError,
    onCompleted,
  });
  const [confirmPickup, { loading: confirmingPickup }] = useMutation(CONFIRM_PICKUP, {
    onError: () => {},
  });
  const { reorder, busyId, dialog: reorderDialog } = useReorder();

  // ── Per-dish thumbs up/down ──────────────────────────────────────────────
  // Load the customer's existing dish votes for this order (server-side
  // ownership-checked). Build a foodId -> vote map the receipt reads to
  // render the pressed thumbs.
  const { data: dishVotesData, refetch: refetchDishVotes } = useApolloQuery(
    MY_DISH_VOTES,
    { variables: { orderId: id }, skip: !id, fetchPolicy: "cache-and-network" }
  );
  const [myVotes, setMyVotes] = useState({});
  useEffect(() => {
    const votes = dishVotesData?.myDishVotesForOrder || [];
    const map = {};
    votes.forEach((v) => { map[String(v.foodId)] = v.vote; });
    setMyVotes(map);
  }, [dishVotesData]);

  const [submitVotes] = useMutation(SUBMIT_DISH_VOTES, {
    onError: () => {},
  });

  const onVoteDish = (foodId, vote) => {
    const key = String(foodId);
    // Optimistic: reflect the tap immediately, then persist.
    setMyVotes((prev) => ({ ...prev, [key]: vote }));
    submitVotes({ variables: { orderId: id, votes: [{ foodId: key, vote }] } })
      .then(() => refetchDishVotes())
      .catch(() => {});
  };

  useEffect(() => {
    async function Track() {
      await Analytics.track(Analytics.events.NAVIGATE_TO_RATEANDREVIEW);
    }
    Track();
  }, []);

  function onFinishRating(rating) {
    setRating(rating);
  }

  function onChangeText(description) {
    setDescription(description);
  }

  function onSubmit() {
    mutate({
      variables: {
        order: id,
        rating: rating,
        description: description,
      },
    });
  }

  function onCompleted(data) {
    closeModal();
  }

  function onError(error) {
    FlashMessage({
      message: error.networkError.result.errors[0].message,
    });
  }

  const closeModal = () => {
    setIsOpen(false);
  };

  useSubscription(
    gql`
      ${subscriptionOrder}
    `,
    { variables: { id } }
  );


  const { loadingOrders, errorOrders, orders, clearCart, fetchOrders } =
    useContext(UserContext);
  const foundOrder = orders.find((o) => o._id === id);
  // A just-placed order can be missing from the cached list (checkout seeds it,
  // but any path that skips that write — a redirect, a cold cache — would leave
  // this screen spinning forever until the customer refreshed by hand). Pull the
  // list once, then stop: a genuinely unknown id must not loop.
  const [triedRefetch, setTriedRefetch] = useState(false);
  useEffect(() => {
    if (!loadingOrders && !foundOrder && id && !triedRefetch) {
      setTriedRefetch(true);
      if (typeof fetchOrders === "function") fetchOrders();
    }
  }, [loadingOrders, foundOrder, id, triedRefetch, fetchOrders]);
  // Embed mode: support/ticket pages live outside the pinned restaurant flow
  const { isEmbed } = useContext(EmbedContext);

  useEffect(async () => {
    await Analytics.track(Analytics.events.NAVIGATE_TO_ORDER_DETAIL, {
      orderId: id,
    });
  }, []);
  useEffect(() => {
    if (!id) {
      navigate("/orders");
    }
    if (queryParams.get("clearCart")) {
      clearCart();
    }
  }, [id]);

  if (errorOrders) {
    return <Centered>{errorOrders.message}</Centered>;
  }
  const order = foundOrder;
  if (loadingOrders || (!order && !triedRefetch)) {
    return (
      <Centered>
        <CircularProgress size={44} sx={{ color: C.red }} aria-label="Loading your order" />
      </Centered>
    );
  }
  // Refetched and still nothing — the id doesn't belong to this account. Say so
  // rather than spinning at the customer indefinitely.
  if (!order) {
    return <Centered>We couldn't find this order.</Centered>;
  }
  const restLat = order.restaurant?.location?.coordinates?.[1] ?? order.restaurant?.location?.latitude;
  const restLng = order.restaurant?.location?.coordinates?.[0] ?? order.restaurant?.location?.longitude;
  restCoordinates = {
    lat: parseFloat(restLat || 0),
    lng: parseFloat(restLng || 0),
  };
  if (!ORDER_STATUS.includes(order.orderStatus)) {
    const destLat = order.deliveryAddress?.location?.coordinates?.[1] ?? order.deliveryAddress?.latitude;
    const destLng = order.deliveryAddress?.location?.coordinates?.[0] ?? order.deliveryAddress?.longitude;
    destCoordinates = {
      lat: parseFloat(destLat || 0),
      lng: parseFloat(destLng || 0),
    };
  }

  const phase = orderPhase(order);
  const live = phase === "live";
  const pickup = isPickupOrder(order);
  const chip = statusChip(order);
  const banner = statusBanner(order, { lateText: t("orderLateText") });
  const timeline = orderTimeline(order);
  const chatOpenable = order?.rider && !["DELIVERED", "CANCELLED", "COMPLETED"].includes(order.orderStatus);
  // The live map: our rider on the move.
  const showMap = Boolean(order?.rider && !pickup && !["DELIVERED", "CANCELLED"].includes(order.orderStatus) && destCoordinates);
  const track =
    phase === "cancelled"
      ? null
      : order.fdTrackerLink
        ? { href: order.fdTrackerLink }
        : { onClick: () => goTo(showMap ? "od-live-map" : "od-timeline") };

  // The driver: ours (rider) or First Delivery's courier.
  const hasOurDriver = Boolean(order.rider?._id);
  // First Delivery's courier: named, or at least on the way (its tracking
  // links exist from the start, before anyone has taken the order). FD
  // doesn't always send every event, so a finished order or a driver status
  // counts too, not only assignedAt.
  const hasFdDriver =
    Boolean(order.fdDriverName) ||
    (Boolean(order.fdTrackerLink || order.fdDspTrackerLink) &&
      (Boolean(order.assignedAt) || phase === "complete" || ["ASSIGNED", "EN_ROUTE_PICKUP", "ARRIVED_PICKUP", "PICKED", "EN_ROUTE_DROPOFF", "ARRIVED_DROPOFF"].includes(order.orderStatus)));
  // FD's driver tracker, as the old card had it: whenever there is a driver, delivered or not.
  const fdDriverTracker = phase !== "cancelled" && hasFdDriver ? order.fdDspTrackerLink || null : null;
  const showDriver = !pickup && phase !== "cancelled" && (hasOurDriver || hasFdDriver);
  const photos = [
    { src: order.fdDropoffPhoto || order.deliveryProofImage, caption: "Photo taken at drop-off" },
    { src: order.pickupReceiptImage, caption: "Pickup receipt" },
  ].filter((p) => p.src);
  const ticket = order.supportTicketId ? TICKET[order.supportTicketStatus] || TICKET.OPEN : null;
  const placedLine = [order.restaurant?.name, dayText(order.createdAt, orderTz(order)), timeText(order.createdAt, orderTz(order))].filter(Boolean).join(" · ");

  return (
    <>
      <PullToRefresh onRefresh={fetchOrders}>
        <Box sx={{ minHeight: "100vh", bgcolor: C.bg }}>
          <Header />
          <Box
            component="main"
            sx={{
              boxSizing: "border-box",
              width: "100%",
              maxWidth: 1120 + 64,
              mx: "auto",
              px: { xs: 2, sm: 3, md: 4 },
              pt: { xs: topBarOffset(16), md: topBarOffset(24) },
              pb: 6,
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            {/* ── Header ── */}
            <Box component="header" sx={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", justifyContent: "space-between", gap: 2 }}>
              <Box sx={{ minWidth: 0 }}>
                <Box
                  component={RouterLink}
                  to="/orders"
                  sx={{ ...FOCUS_RING, display: "inline-flex", alignItems: "center", gap: 0.25, ml: -0.5, mb: 1, px: 0.5, minHeight: 32, borderRadius: "8px", fontFamily: FONT_BODY, fontSize: 14, fontWeight: 600, color: C.redLink, textDecoration: "none", "&:hover": { textDecoration: "underline" } }}
                >
                  <ChevronLeftRoundedIcon aria-hidden="true" sx={{ fontSize: 20 }} />
                  My orders
                </Box>
                <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1.5 }}>
                  <Box component="h1" sx={{ m: 0, fontFamily: FONT_DISPLAY, fontSize: { xs: 26, sm: 32 }, fontWeight: 800, letterSpacing: "-0.02em", lineHeight: 1.1, color: C.ink }}>
                    Order #{order.orderId}
                  </Box>
                  <StatusPill chip={chip} />
                </Box>
                {placedLine && (
                  <Box component="p" sx={{ m: 0, mt: 0.75, fontFamily: FONT_BODY, fontSize: 15, color: C.muted }}>
                    {placedLine}
                  </Box>
                )}
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {!isEmbed && (
                  <Box component={RouterLink} to={`/get-help/${order._id}`} sx={outlineButtonSx(false)}>
                    <HeadsetMicOutlinedIcon aria-hidden="true" sx={{ fontSize: 20 }} />
                    Get help
                  </Box>
                )}
                {!live && order.items?.length > 0 && (
                  <Box component="button" type="button" onClick={() => reorder(order)} disabled={busyId === order._id} aria-busy={busyId === order._id} sx={redButtonSx}>
                    {busyId === order._id ? <CircularProgress size={18} sx={{ color: "inherit" }} /> : <RefreshRoundedIcon aria-hidden="true" sx={{ fontSize: 20 }} />}
                    Reorder
                  </Box>
                )}
              </Box>
            </Box>

            <StatusBanner banner={banner} track={track} trackDriverHref={fdDriverTracker} />

            {/* ── Pickup confirmation: the customer marks their order collected ── */}
            {order.isPickedUp && !isInStoreOrder(order) && order.orderStatus === "PREPARED" && (
              <Box
                component="button"
                type="button"
                disabled={confirmingPickup}
                onClick={() => confirmPickup({ variables: { id: order._id } })}
                sx={{ ...redButtonSx, bgcolor: C.green, minHeight: 52, borderRadius: "16px", fontSize: 16, "&:hover:not(:disabled)": { bgcolor: "#124F2E" } }}
              >
                {confirmingPickup ? "Confirming…" : (
                  <>
                    <CheckRoundedIcon aria-hidden="true" />
                    I've Picked Up My Order
                  </>
                )}
              </Box>
            )}

            <Box sx={{ display: "grid", gridTemplateColumns: { xs: "minmax(0, 1fr)", md: "minmax(0, 1fr) minmax(340px, 420px)" }, gap: "24px", alignItems: "start" }}>
              {/* Left: the live map, timeline, driver and details. */}
              <Box sx={{ display: "flex", flexDirection: "column", gap: "24px", minWidth: 0 }}>
                {showMap && (
                  <DetailCard id="od-live-map" tabIndex={-1} aria-labelledby="od-map-title" sx={{ p: 0, overflow: "hidden", scrollMarginTop: topBarOffset(16), "&:focus": { outline: "none" } }}>
                    <Box sx={{ px: { xs: "20px", sm: "24px" }, py: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2 }}>
                      <CardTitle id="od-map-title">Live tracking</CardTitle>
                      <Box sx={{ fontFamily: FONT_BODY, fontSize: 14, color: C.muted }}>{order.rider.name} is on the way</Box>
                    </Box>
                    <Box sx={{ height: { xs: 300, sm: 360 }, width: "100%" }}>
                      <LiveTrackingMap orderStatus={order.orderStatus} restCoordinates={restCoordinates} destCoordinates={destCoordinates} riderId={order.rider._id} />
                    </Box>
                  </DetailCard>
                )}

                <Box id="od-timeline" tabIndex={-1} sx={{ scrollMarginTop: topBarOffset(16), "&:focus": { outline: "none" } }}>
                  <Timeline timeline={timeline} phase={phase} />
                </Box>

                {showDriver && (
                  <DriverCard
                    name={hasOurDriver ? order.rider.name || "Driver" : order.fdDriverName || "Driver assigned"}
                    phone={hasOurDriver ? order.rider.phone : order.fdDriverPhone}
                    photo={hasOurDriver ? order.rider.pictureUrl : order.fdDriverPhoto}
                    caption={deliverySource(order) === "RESTAURANT" ? "Your restaurant driver" : "Your driver"}
                    transport={hasOurDriver ? null : order.fdDriverTransport}
                    live={live}
                    onChat={hasOurDriver && chatOpenable ? () => setToggleChat(true) : undefined}
                    unreadChat={unreadChat}
                    trackDriverHref={fdDriverTracker}
                    onTrackDriver={live && !order.fdDspTrackerLink && showMap ? () => goTo("od-live-map") : undefined}
                    photos={photos}
                  />
                )}

                <DeliveryDetails order={order} />
              </Box>

              {/* Right: the receipt, kept in view under the top bar. */}
              <Box sx={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0, position: { md: "sticky" }, top: { md: topBarOffset(16) } }}>
                <Receipt order={order} canRateDishes={order.orderStatus === "DELIVERED"} myVotes={myVotes} onVoteDish={onVoteDish} />
                {chatOpenable && !toggleChat && (
                  <Box sx={{ display: { xs: "none", md: "block" } }}>
                    <ChatWithRider unread={unreadChat} onClick={() => setToggleChat(true)} />
                  </Box>
                )}
                {!isEmbed && ticket && (
                  <Box sx={{ p: 2, borderRadius: "16px", bgcolor: ticket.bg, display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.25, flex: 1, minWidth: 180 }}>
                      <Box aria-hidden="true" sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: ticket.dot, flexShrink: 0 }} />
                      <Box sx={{ fontFamily: FONT_BODY }}>
                        <Box sx={{ fontSize: 14, fontWeight: 700, color: ticket.color }}>{ticket.title}</Box>
                        <Box sx={{ fontSize: 13, color: ticket.color }}>{ticket.text}</Box>
                      </Box>
                    </Box>
                    <Box component={RouterLink} to={`/ticket-detail/${order.supportTicketId}`} sx={outlineButtonSx(false)}>
                      View my ticket
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>

            <AppPromo />
          </Box>
        </Box>
      </PullToRefresh>

      {/* ── Chat with the driver: always reachable once a rider is assigned.
          Floating on phones; on wide screens it sits under the receipt. ── */}
      {chatOpenable && !toggleChat && (
        <Box sx={{ display: { xs: "block", md: "none" }, position: "fixed", right: 16, bottom: 16, zIndex: 1200 }}>
          <ChatWithRider unread={unreadChat} onClick={() => setToggleChat(true)} floating />
        </Box>
      )}
      {toggleChat && chatOpenable && <Chat setToggleChat={setToggleChat} id={order?._id} />}

      {reorderDialog}

      <Modal isOpen={isOpen} onRequestClose={closeModal}>
        <CloseIcon className={classes.closeButton} onClick={closeModal} />
        <div className={classes.modalContainer}>
          <div className={classes.title}>
            <h2>Write a Review</h2>
          </div>
          <div className={classes.starContainer}>
            <div className={classes.starWrapper}>
              <StarRatings
                maxStars={5}
                rating={rating}
                changeRating={onFinishRating}
                starDimension={mobile ? "20px" : "50px"}
                starRatedColor={theme.palette.primary.main}
              />
            </div>
          </div>
          <div className={classes.inputContainer}>
            <input
              className={classes.input}
              placeholderTextColor={theme.palette.secondary.dark}
              onChange={(e) => onChangeText(e.target.value)}
              placeholder="More detailed reviews get more visibility..."
            />
          </div>
          <div className={classes.submitContainer}>
            <div className={classes.submit}>
              {loadingMutation && <ThreeDots />}
              {!loadingMutation && (
                <button
                  onClick={onSubmit}
                  className={classes.submitButton}
                  disabled={rating < 2 || description.length < 1}
                >
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
        <div className={classes.backdrop} />
      </Modal>
      <FlashMessage
        open={Boolean(loyaltyMsg)}
        severity="success"
        alertMessage={loyaltyMsg}
        handleClose={() => setLoyaltyMsg(null)}
      />
    </>
  );
}

export default OrderDetail;
